module.exports = __webpack_public_path__ + "img/svg/step9.d66f0bd27adc27498340627b3a406178.svg";